import { render, staticRenderFns } from "./Angels.vue?vue&type=template&id=fb21a306&scoped=true&"
import script from "./Angels.vue?vue&type=script&lang=js&"
export * from "./Angels.vue?vue&type=script&lang=js&"
import style0 from "./Angels.vue?vue&type=style&index=0&id=fb21a306&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb21a306",
  null
  
)

export default component.exports